import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	scrumTemplateTitle: {
		id: 'project-create-importer-upload-flow.common.constants.steps.scrum-template-title',
		defaultMessage: 'Scrum',
		description: 'Scrum template card title',
	},
	scrumTemplateDescription: {
		id: 'project-create-importer-upload-flow.common.constants.steps.scrum-template-description',
		defaultMessage: 'Sprint toward your project goals with a board, backlog, and timeline.',
		description: 'Scrum template card description',
	},
	kanbanTemplateTitle: {
		id: 'project-create-importer-upload-flow.common.constants.steps.kanban-template-title',
		defaultMessage: 'Kanban',
		description: 'Scrum template card title',
	},
	kanbanTemplateDescription: {
		id: 'project-create-importer-upload-flow.common.constants.steps.kanban-template-description',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			'Visualise and advance your project forward using issues on a powerful board.',
		description: 'Scrum template card description',
	},
});
